module.exports = __webpack_public_path__ + "img/game6.206b28f8.png";